import DocumentsComponent from "../../../components/common/attachments/baseDocumentDetails";
import CommentsComponent from "../../../components/common/clickup/communication/comments";
import FieldsComponent from "../../../components/common/clickup/dataGrid/fieldsDisplay";
import CustomizedTitle from "../../../components/customizedTitle/CustomizedTitle2";
import useTaskComments from "../../../hooks/clickup/useClickupComments";
import useTaskData from "../../../hooks/clickup/useClickupData";
import Sidebar from "../../../components/sidebar/Sidebar";
import { useParams, useLocation } from "react-router-dom";
import NavBar from "../../../components/navbar/NavBar";
import verifyToken from "../../../utils/tokenUtils";
import { useNavigate } from 'react-router-dom';
import '../poStatusReport/poStatusReport.css';
import React, {useEffect} from "react";
import Cookies from 'js-cookie';

const TaskDetailPage = () => {
  const navigate = useNavigate();
  const getAuthToken = () => { return Cookies.get('gtms-cp-auth'); };

  useEffect(() => { 
    const token = getAuthToken();
    token ? verifyToken(token) : navigate('/');
  }, []);
  
  const { taskname } = useParams();
  const location = useLocation();
  const taskID = location.state?.taskID;
  const { taskData } = useTaskData(taskID);
  const { taskComments } = useTaskComments(taskID);
  const titleObject = {title: taskname}

  // Loading state
  if (!taskData) {
    return <p>Loading...</p>;
  }

  //this was done in an effort to make the component more re-usable, we pass the custom fields here that we are wanting to get
  const customFieldValues = {
    "c5086241-8e5f-47ba-934a-6db67f59285e": "BOL#",
    "edfbdd2f-caf6-4c3a-beb8-ef1c3f443486": "Estimated Date on Property",
    "7b04d745-6e55-4038-97d3-1b9f60a54ec4": "Pro#",
    "be29aa53-1074-4dc1-9a45-fef6b701ae6f": "Delivery Appt. Date",
    "8f06f9c2-dded-4db8-8262-f8a6690eb623": "Pickup#",
    "a335c31d-8486-4153-91ca-975ea9e44b17": "Actual Delivery Date",
    "b50678e1-6b3a-4425-9838-5f487833fad9": "Purchase Order#",
    "5b4358e7-9a1f-48e0-9947-4e85d4df48b2": "Delivery Appointment Time",
    "ff8c3d56-2eca-494d-bdad-4a64e1ac8234": "Sales Order#",
    "fd338885-b092-46db-bed8-bc83a4c22af6": "Days Since Delivery",
    "2b0b75da-e202-4670-b35e-2750c8b241de": "Supplier Name",
    "f1467a95-455e-41d7-bd17-f2306206c0a2": "Requesting Company Name",
    "1e25f0f2-7e96-4784-84d6-b66d2739e472": "Pickup Date",
    "d62c3356-0f0a-43e8-a47f-1f07af9017e7": "Carrier Name",
    "ea29a985-c5e4-45b7-a2d7-9b231c5ac0d7": "Shipment Total Cost",
    "970c5387-f05f-4235-961b-b47e6060d3f8": "Pallet Count",
    "ccfddc78-4a63-47db-81d8-aea0831c0b15": "Origin Name",
    "e9ef5220-a08a-443d-bced-400eefd47cfc": "Tracking Link",
    "50dc73ae-6901-4d42-804a-8dd42d0c54dc": "Consignee Name"
  };
  const customFieldValuesDocs = {
    "3ff7c86a-9241-4f8b-b75e-c455dc3cb205": "Packing List",
    "fde8c17a-e560-4e82-b8cb-ffb7d54703ce": "CoA / CoC",
    "65bdfac2-01f4-448a-9578-fe41a7da8b5d": "POD",
    "f02b61cc-834f-4c45-aa96-4a1b5f4ff3c5": "BOL"
  }

  return (
    <div className="taskInformationPage">
      <div className="LandingPageContainer">
        <NavBar />
        <Sidebar />
        <div className="taskInformationPageContent">
          <div className="taskInformationTop">
            <div className="taskInformationTitle">
              <CustomizedTitle titleObject={titleObject}/>
              {/* <h1 style={{marginLeft: '100px'}}>{taskname}</h1> */}
              <div className="taskComponentHolder">
                <div className="smallComponentHolder">
                  <div className="compBorder fieldPadding">
                    <h3 style={{marginBottom: '-10px'}}>Documents:</h3>
                    <DocumentsComponent
                      taskData={taskData}
                      customFieldValues={customFieldValuesDocs}
                    />
                  </div>
                  <div className="compBorder fieldPadding" style={{marginTop: '25px'}}>
                    <div className="taskDetailFieldHeader">
                      <h3>Fields:</h3>
                      <div style={{marginTop: '20px'}}>
                        <a 
                          href="https://gtms.clickup.com/forms/37415501/f/13nujd-18293/ZH5BR89TULHPV7E8G9" 
                          target="_blank"  rel="noopener noreferrer" style={{textDecoration: 'none'}}
                        >
                          <button className="claimButton">Open Claim</button>
                        </a>
                      </div>
                    </div>
                    <FieldsComponent
                      taskData={taskData}
                      customFieldValues={customFieldValues}
                    />
                  </div>
                </div>
                <div className="compBorder fieldsSection commentHolder">
                  <h3>Comments:</h3>
                  <CommentsComponent
                    taskComments={taskComments}
                    taskID={taskID}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="taskInformationBottom"></div>
        </div>
      </div>
    </div>
  );
};

export default TaskDetailPage;
